import { useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ReviewViewContent } from 'pages/reviews/ui/ReviewViewContent/ReviewViewContent'
import { ReviewViewStore } from 'pages/reviews/store'
import { ReviewViewContext } from 'pages/reviews/context/reviewViewContext'

export const CreateReview = () => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new ReviewViewStore(entities))

  return (
    <ReviewViewContext.Provider value={store}>
      <ReviewViewContent />
    </ReviewViewContext.Provider>
  )
}
